export const SITE_URL = "https://roava.lovable.app";
export const SITE_NAME = "Roava by WGP Apps";

/** Build a shareable URL with a cache-busting query param so iMessage/social
 *  scrapers always fetch a fresh preview instead of using a stale cached one. */
export function shareUrl(path = "/") {
  const url = new URL(path, SITE_URL);
  url.searchParams.set("s", Math.random().toString(36).slice(2, 8));
  return url.toString();
}

export function pageMeta(opts: {
  title: string;
  description: string;
  path: string;
  image?: string;
  type?: "website" | "article";
}) {
  const { title, description, path, image, type = "website" } = opts;
  const url = `${SITE_URL}${path}`;
  const meta: Array<Record<string, string>> = [
    { name: "description", content: description },
    { property: "og:site_name", content: SITE_NAME },
    { property: "og:title", content: title },
    { property: "og:description", content: description },
    { property: "og:type", content: type },
    { property: "og:url", content: url },
    { name: "twitter:card", content: image ? "summary_large_image" : "summary" },
    { name: "twitter:title", content: title },
    { name: "twitter:description", content: description },
  ];
  if (image) {
    meta.push(
      { property: "og:image", content: image },
      { name: "twitter:image", content: image },
    );
  }
  return {
    title,
    meta,
    links: [{ rel: "canonical", href: url }],
  };
}
